import {icon, LatLng, latLng, LatLngBounds, tileLayer} from 'leaflet';

export class LeafletService {
  constructor() {}

  public createLeafletDefaultMapOptions(): any {
    return {
      layers: [
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18})
      ],
      zoom: 1,
      center: latLng(0, 0),
      attributionControl: false,
    };
  }

  public createLeafletDefaultMarkerOptions(tooltip: string): any {
    return {
      icon: icon({
        iconSize: [ 25, 41 ],
        iconAnchor: [ 13, 41 ],
        iconUrl: 'assets/marker-icon.png',
        shadowUrl: 'assets/marker-shadow.png'
      }),
      title: tooltip
    };
  }

  public getEmptyBounds(): LatLngBounds {
    return new LatLngBounds(new LatLng(0, 0), new LatLng(0, 0));
  }
}

